export * from './act-as-callback.component';
